// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","root":"_3GHTbhxpPGandcyH"};